import { useEffect, useState } from "react";
import api, { fmtINR } from "@/lib/api";
import PageHero from "@/components/layout/PageHero";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import { Check, ArrowRight, Timer } from "lucide-react";

export default function Packages() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/packages").then(({ data }) => setItems(data)).catch(() => {}); }, []);

  return (
    <div data-testid="packages-page">
      <PageHero
        kicker="Holiday Packages"
        title="Curated holiday bundles, fully planned"
        subtitle="Flights, hotels, transfers and experiences — everything done for you in one package price."
      />
      <div className="container-page py-10">
        <Breadcrumbs items={[{ label: "Packages" }]} />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {items.map((p) => (
            <div key={p.id} data-testid={`package-${p.id}`} className="bg-white border border-slate-200 rounded-2xl overflow-hidden card-hover flex flex-col md:flex-row">
              <div className="md:w-48 h-48 md:h-auto relative shrink-0">
                <img src={p.image} alt={p.title} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                <span className="absolute top-3 left-3 px-2 py-1 text-[10px] uppercase tracking-widest font-bold rounded bg-white/95 text-brand">{p.category}</span>
              </div>
              <div className="p-5 flex-1">
                <h3 className="font-montserrat font-bold text-lg text-slate-900">{p.title}</h3>
                <div className="text-xs text-slate-500 mt-1 inline-flex items-center gap-1"><Timer size={12} /> {p.duration} · {p.destination}</div>
                <ul className="mt-3 space-y-1.5">
                  {p.inclusions.slice(0, 4).map((inc) => (
                    <li key={inc} className="text-sm text-slate-700 inline-flex items-start gap-2">
                      <Check size={14} className="text-brand mt-0.5 shrink-0" /> {inc}
                    </li>
                  ))}
                </ul>
                <div className="mt-4 flex items-end justify-between">
                  <div>
                    <div className="text-[11px] text-slate-500">From</div>
                    <div className="text-xl font-montserrat font-bold text-slate-900">{fmtINR(p.from_price)}</div>
                  </div>
                  <a href="https://www.makemytrip.com" target="_blank" rel="noopener sponsored" className="inline-flex items-center gap-1 px-4 h-10 rounded-lg btn-accent font-semibold text-sm">
                    View Package <ArrowRight size={14} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
